<template>
  <div class="flex justify-content-between gap-2 p-2">
    <div class="text-center text-xs text-gray-400">
      Front: v{{ frontendVersion }}
    </div>
    <div class="text-center text-xs text-gray-400">
      Back: v{{ backendVersion }}
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useAxios } from "@sttedra_ui/framework";

const frontendVersion = require("../../../package.json")?.version;

// #region Props, Emits
// #endregion

// #region Params, Ref, Reactives, Computed
const { base } = useAxios();

const timeout = 5000;
const backendVersion = ref(null);
// #endregion

// #region Functions// Get user rol
async function getVersion() {
  const url = `/version.json`;

  // Make the request
  const response = await base.get(
    url,
    {},
    {
      timeout,
    }
  );

  backendVersion.value = response.data?.version;
}
// #endregion

// #region Effects, Hooks
onMounted(() => {
  getVersion();

  if (
    (frontendVersion.includes("pre") || frontendVersion.includes("pro")) &&
    window.location.href.includes("localhost")
  ) {
    alert(
      // eslint-disable-next-line max-len
      "Estás desarrollando en una versión de pre-producción o producción. Por favor, no olvides cambiar a la versión de desarrollo."
    );
  }
});
// #endregion

// #region Provide, Expose
// #endregion
</script>
